import { themeAtom } from "../../shared/atoms";
import { CheckboxProps } from "../models/search.interfaces";
import { useAtomValue } from "jotai";
import { twMerge } from "tailwind-merge";

export const Checkbox: React.FC<CheckboxProps> = ({ label, isChecked, onChange }) => {
  const theme = useAtomValue(themeAtom);

  return (
    <label className="flex items-center">
      <input
        type="checkbox"
        checked={isChecked}
        onChange={onChange}
        className={twMerge("border", theme.headerComponent.notifications.headerBorder)}
      />
      <span className={twMerge("text-sm", theme.home.tailwind.textDefault)}>{label}</span>
    </label>
  );
};
